import React from 'react';
import Loading from 'client/component-library/LoadingIcon';
import { useFormUtilsContext } from 'client/modules/common/form/containers/hooks/useFormUtilsContext';
import { DealCard } from 'client/modules/news/queue/components/DealCard';
import { DealCard as DealCardModel } from 'client/modules/news/queue/apis/GetDealQueue';
import {
  UpdateMergeOptions,
  UpdateTarget,
} from 'client/modules/news/queue/utils/dealUpdate';

interface DealQueueListProps {
  dealCards: DealCardModel[];
  isLoading: boolean;
}

interface DealQueueContext {
  onPublish: (card: DealCardModel) => void;
  onReject: (card: DealCardModel) => void;
  onSkip: (card: DealCardModel) => void;
  onUpdate: (
    card: DealCardModel,
    target: UpdateTarget,
    merge: UpdateMergeOptions
  ) => void;
}

export const DealQueueList = ({ dealCards, isLoading }: DealQueueListProps) => {
  const {
    customContext: { onPublish, onReject, onSkip, onUpdate },
  } = useFormUtilsContext() as unknown as { customContext: DealQueueContext };

  if (isLoading) {
    return <Loading />;
  }

  if (!dealCards.length) {
    return (
      <div className="flex w-full justify-center">
        There are no deals to review right now
      </div>
    );
  }

  return (
    <div>
      <div className="flex flex-row w-full font-bold text-xs text-gray-500 mb-1">
        <div className="w-10/12 pl-4 flex justify-start">DEAL</div>
        <div className="w-2/12 px-1 flex justify-start">ACTIONS</div>
      </div>
      {dealCards.map((card) => (
        <div key={card.idNewsDeal}>
          <DealCard
            {...card}
            onPublish={onPublish}
            onReject={onReject}
            onSkip={onSkip}
            onUpdate={onUpdate}
          />
        </div>
      ))}
    </div>
  );
};

export default DealQueueList;
